import { Component, effect, input } from '@angular/core';
import { StudentSchedule } from './student-schedule';
import { UserAvatarComponent } from '../../../../../shared/components/user-avatar/user-avatar.component';
import { CommonModule } from '@angular/common';
import { TagComponent } from '../../../../../shared/components/tag/tag.component';
import { GetRideStatusSeverity } from '../../../../../shared/enums/rideStatusType';
import { TimeFormatPipe } from '../../..../../../../../shared/pipes/time-format.pipe';

@Component({
  selector: 'app-student-schedule',
  standalone: true,
  imports: [CommonModule, UserAvatarComponent, TagComponent, TimeFormatPipe],
  templateUrl: './student-schedule.component.html',
  styleUrl: './student-schedule.component.scss',
})
export class StudentScheduleComponent {
  readonly studentSchedule = input<StudentSchedule | null>(null);
  readonly avatarUrl = input<string | null>(null);

  constructor() {
    effect(() => this.processSchedule());
  }

  private processSchedule() {
    const studentSchedule = this.studentSchedule();
    if (studentSchedule) {
      studentSchedule.schedule.forEach(day => {
        const today = new Date();
        const yesterday = new Date();
        const tomorrow = new Date();
        yesterday.setDate(today.getDate() - 1);
        tomorrow.setDate(today.getDate() + 1);

        const dayDate = new Date(day.date || '');
        const itemDay = dayDate.toDateString();

        switch (itemDay) {
          case today.toDateString():
            day.dateString = '(Today)';
            break;
          case yesterday.toDateString():
            day.dateString = '(Yesterday)';
            break;
          case tomorrow.toDateString():
            day.dateString = '(Tomorrow)';
            break;
          default:
            day.dateString = undefined;
        }

        day.rides.forEach(ride => {
          ride.statusSeverity = GetRideStatusSeverity(ride.status, false);
        });

        // Sort rides by start time
        day.rides.sort((a, b) => {
          const timeA = this.parseTimeToMinutes(a.startTime);
          const timeB = this.parseTimeToMinutes(b.startTime);
          return timeA - timeB;
        });
      });
    }
  }

  /**
   * Parse start time string to minutes from midnight for comparison
   * Handles time string format like "06:35:00" or "14:20:00"
   */
  private parseTimeToMinutes(startTime: string): number {
    const timeParts = startTime.split(':');
    if (timeParts.length >= 2) {
      const hours = Number.parseInt(timeParts[0], 10);
      const minutes = Number.parseInt(timeParts[1], 10);

      if (!Number.isNaN(hours) && !Number.isNaN(minutes)) {
        return hours * 60 + minutes;
      }
    }
    return 0; // Default fallback for invalid time format
  }
}
